export enum REPORT_TYPE {
  CONTRACTS = 'contracts',
  RTS = 'RTS',
  LICENSES = 'licenses',
  AGENTS = 'agents',
  SALES = 'sales',
}
